import { request, requestPaginated } from '../api.js';
import type { NotificationDto, PaginationMeta, UnreadCountResponse } from '@cosvision/shared';

export function listNotifications(
  opts: { unreadOnly?: boolean; page?: number; limit?: number } = {},
): Promise<{ data: NotificationDto[]; meta: PaginationMeta }> {
  const params = new URLSearchParams();
  if (opts.unreadOnly) params.set('unreadOnly', 'true');
  if (opts.page) params.set('page', String(opts.page));
  if (opts.limit) params.set('limit', String(opts.limit));
  const qs = params.toString();
  return requestPaginated<NotificationDto>('get', qs ? `/notifications?${qs}` : '/notifications');
}

export function getNotificationUnreadCount(): Promise<UnreadCountResponse> {
  return request<UnreadCountResponse>('get', '/notifications/unread-count');
}

export function markNotificationRead(id: string): Promise<{ read: boolean }> {
  return request<{ read: boolean }>('post', `/notifications/${id}/read`);
}

export function markAllNotificationsRead(): Promise<{ updated: number }> {
  return request<{ updated: number }>('post', '/notifications/read-all');
}
